// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_DM7U6 {
  padding: 0px 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.clientsHeader_gp0g4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 10px;
  padding: 10px 10px 0px;
  width: 95%;
  min-height: 110px;
  box-sizing: border-box;

  .searchContainer_NOGJg {
    display: flex;
    align-items: center;
    gap: 20px;
  }
}

.clientsTable_OsJ2z {
  width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  border: 1px solid var(--eaecf0-border);
  display: flex;
  flex-direction: column;
  max-height: 70vh;
  overflow: hidden;
}

.inputWrapperHover_K7lDh {
  position: relative;
  height: 28px;
  width: 28px;
  min-width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inputWrapperHover_K7lDh:hover {
  .inputContainer_WSz_C {
    opacity: 1;
  }
}

.inputContainer_WSz_C {
  background-color: var(--_52525261-background);
  transition: all 300ms;
  width: 25px;
  border-radius: 999px;
  height: 25px;

  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
}

.inputWrapper_t48oo {
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  border-radius: 0 10px 10px 0;
}

.searchInput_qRyzl {
  padding: 10px 10px 10px 35px;
  border: 1px solid var(--ccc-border);
  border-radius: 10px;
  font-size: 16px;
  outline: none;
  width: 250px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;

  &::placeholder {
    color: var(--aaa-color);
  }
}




.addButton_vouox {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 40px;
  width: 40px;
  background-color: var(--_10A37F-background);
  color: var(--white-color);
  border: none;
  cursor: pointer;
  font-size: 16px;
  border-radius: 7px;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  -ms-border-radius: 7px;
  -o-border-radius: 7px;

  img {
    width: 15px;
    height: 15px;
  }

  &:hover {
    background-color: var(--_122521-background);
  }
}



.name_DLAmD {
  color: var(--_3-color);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;

  img {
    width: 30px;
    height: 30px;
  }

  >div {
    display: flex;
    flex-direction: column;
  }
}


.table_JsmAl {
  min-width: 100%;
  text-align: start;
  table-layout: fixed;
  border-collapse: collapse;
  width: fit-content;


  thead {
    background-color: var(--f5-background);
    position: sticky;
    top: 0;
    z-index: 10;
  }


  tbody {
    background-color: var(--white-background);

    p {
      margin: 0;
    }

    tr {
      border-top: 1px solid var(--eaecf0-border);
      border-bottom: 1px solid var(--eaecf0-border);
      height: 20px;
      width: 100%;
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  th {
    text-align: start;
    padding: 4px 10px 4px 0px;
    color: var(--_3-color);
    font-weight: 500;
    width: 150px;
    color: var(--_6-color);
    font-size: 14px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    z-index: 1;
    width: 20px;
  }

  th:first-child {
    background-color: var(--f5-background);
    z-index: 11;
  }

  td {
    padding: 10px;
    color: var(--_6-color);
    font-size: 13px;
    height: 20px;
    position: relative;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    p {
      margin: 0;
    }

    &:first-of-type {
      display: inline-table;
      background: var(--white-color);
      margin-top: 13px;
      min-width: 20px;
      width: 20px;
      max-width: 20px;
    }

    &:empty {
      position: relative;
    }

    &:empty::after {
      content: " - - ";
      color: var(--_1d-color);
      font-size: 10px;
      font-style: italic;
      position: absolute;
      left: 50%;
      transform: translate(-40px, -10px);
      background: linear-gradient(90deg, var(--f5-background) 0%, var(--white-background) 50%, var(--f5-background) 100%);
      background-size: 200% 100%;
      animation: wave_M7LMa 2s ease-in-out infinite;
      padding: 5px 8px;
      border-radius: 10px;
      z-index: 0;
    }
  }


  thead th {
    white-space: nowrap;
    text-transform: capitalize;
    padding-left: 4px;
  }



  td p:first-of-type {
    margin-bottom: 0;
    display: flex;
    align-items: center;
    gap: 5px;
  }
}

.actions_sO7jz {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  img {
    cursor: pointer;
  }
}

@keyframes wave_M7LMa {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

.transacciones_hym2Z {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100px;

  a {
    font-weight: bold;
  }

  a,
  span {
    color: var(--_073f31-color);
  }
}


.transacciones_hym2Z {
  display: flex;
  flex-direction: column;
  gap: 3px;

  a {
    font-weight: bold;
  }

  a,
  span {
    color: var(--_073f31-color);
  }
}

input[type="checkbox"] {
  width: 15px;
  height: 15px;
}

.bg_IqgAH {
  background-color: var(--_FFFFFF80-background);
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.newClientContainer_UrAE1 {
  background-color: var(--white-background);
  padding-bottom: 20px;
  height: 80vh;
  width: 80%;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  animation: scaleUp_Om2Hk 300ms ease-out forwards;
  -webkit-animation: scaleUp_Om2Hk 300ms ease-out forwards;

  &::-webkit-scrollbar {
    display: none;
  }




}

.typeClient_rUjka {
  display: flex;
  background-color: var(--f3-background);
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  padding: 6px;
  gap: 10px;
  width: 300px;

  button {
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    flex: 1 1;
    background-color: transparent;
  }
}

.typeClientActivate_DDe3x {
  button {
    background-color: transparent;
    cursor: pointer;
    color: var(--_9-color);
  }

  .selected_dRx23 {
    background-color: var(--white-background);
    box-shadow: 0px 3px 8px var(--ac-shadow);
    color: var(--black-color);
  }
}

.typeClientDisabled_Qb0ej {
  background-color: transparent;
}

.button_Rd1Kc {
  cursor: pointer;
  background-color: transparent;
  text-decoration: underline;
  font-weight: 600;
  color: var(--_18181b_color);
  font-size: 14px;
}



.headerPhoneNumer_gRuaA {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

.unknown_K9jjd {
  font-size: 14px;
  font-weight: 400;
  color: var(--_71-color);
}

.phoneNumber_ObyJn {
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 10px;
}

.buttonPhoneContainer_BZ5w6 {
  display: flex;
  align-items: center;
  gap: 10px;
}

.phoneContainerUnknown_xxRF6 {
  display: flex;
  width: 100%;
}

.phoneContainer_fCxBl {
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
  flex-direction: column;

  .phoneRow_HiQRF {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .delete_rocMs {
    background-color: var(--dc3545-background);
    height: 20px;
    min-width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    cursor: pointer;

    .icon_bjOLl {
      height: 13px;
      width: 13px;
    }
  }
}

.searchIconsWrappers_Uhx3e {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}


.thPointer_WoGIM {
  cursor: pointer;
}

.thWithInitial_wdEbQ {
  cursor: pointer;
  position: initial
}

.thInitial_L786p {
  position: initial
}

.thInitial_L786p:hover .chevronIcon_GExD2 {
  opacity: 1;
}


.chevronIcon_GExD2 {
  opacity: 0;
  transition: opacity 0.3s ease;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  min-width: 12px;
  min-height: 12px;
}


.thPointer_WoGIM:hover .chevronIcon_GExD2 {
  opacity: 1;
}

.thWithInitial_wdEbQ:hover .chevronIcon_GExD2 {
  opacity: 1;
}







.seeMoreContainer_P1zoW {
  display: flex;
  justify-content: end;
  color: var(--_6-color);
  cursor: pointer;
}

.columnTitle_e37Im {
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    color: var(--black-color);
    display: flex;
    align-items: center;
    gap: 3px;

    button {
      background-color: transparent;
      outline: none;
      border: none;
      left: -5px;
      position: relative;

      .icon_bjOLl {
        opacity: 0;
        background-color: transparent;
        outline: none;
        border: none;
        cursor: pointer;
      }
    }
  }

  div {
    text-decoration: underline;
  }
}

.thPointer_WoGIM:hover .icon_bjOLl {
  opacity: 1;
}

.thWithInitial_wdEbQ:hover .icon_bjOLl {
  opacity: 1;
}

.thPointer_WoGIM:hover .icon_bjOLl {
  opacity: 1;
}

.thInitial_L786p:hover .icon_bjOLl {
  opacity: 1;
}

.theadShowThead_pJJd1 {
  z-index: 1 !important;
}

.theadHideThead_DdoBk {
  z-index: 10 !important;
}

.scrollWrapper_WNP8k {
  flex: 1 1;
  overflow: auto;
  width: 100%;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.scrollWrapper_WNP8k::-webkit-scrollbar {
  display: none;
}

.resizer_Wj0eM {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 5px;
  cursor: col-resize;
  z-index: 10;
}

.iconParameter_eMvqL{
  width: 20px;
  height: 20px;
  fill: var(--_3-color);
  color: var(--_3-color);
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/DynamicTable/DynamicTable.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,sBAAsB;;EAEtB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,WAAW;EACX,oBAAoB;EACpB,YAAY;;EAEZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;;EAEtB;IACE,uBAAuB;EACzB;AACF;;;;;AAKA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,2CAA2C;EAC3C,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;;EAErB;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2CAA2C;EAC7C;AACF;;;;AAIA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;;AAGA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;;;EAGlB;IACE,sCAAsC;IACtC,gBAAgB;IAChB,MAAM;IACN,WAAW;EACb;;;EAGA;IACE,yCAAyC;;IAEzC;MACE,SAAS;IACX;;IAEA;MACE,0CAA0C;MAC1C,6CAA6C;MAC7C,YAAY;MACZ,WAAW;MACX,eAAe;;MAEf;QACE,mBAAmB;MACrB;IACF;EACF;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,eAAe;;IAEf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,WAAW;EACb;;EAEA;IACE,sCAAsC;IACtC,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,kBAAkB;;IAElB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;;IAEnB;MACE,SAAS;IACX;;IAEA;MACE,qBAAqB;MACrB,8BAA8B;MAC9B,gBAAgB;MAChB,eAAe;MACf,WAAW;MACX,eAAe;IACjB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,uBAAuB;MACvB,eAAe;MACf,kBAAkB;MAClB,kBAAkB;MAClB,SAAS;MACT,kCAAkC;MAClC,mHAAmH;MACnH,0BAA0B;MAC1B,6CAAuC;MACvC,gBAAgB;MAChB,mBAAmB;MACnB,UAAU;IACZ;EACF;;;EAGA;IACE,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;EACnB;;;;EAIA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;;EAET;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;;EAEZ;IACE,iBAAiB;EACnB;;EAEA;;IAEE,2BAA2B;EAC7B;AACF;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER;IACE,iBAAiB;EACnB;;EAEA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,oBAAoB;EACpB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,gDAA0C;EAC1C,wDAAkD;;EAElD;IACE,aAAa;EACf;;;;;AAKF;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,YAAY;;EAEZ;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,SAAO;IACP,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,yCAAyC;IACzC,wCAAwC;IACxC,yBAAyB;EAC3B;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,sBAAsB;;EAEtB;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;;IAEf;MACE,YAAY;MACZ,WAAW;IACb;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,UAAU;EACV,6BAA6B;EAC7B,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;;;;;;AAQA;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB;IACE,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;;IAER;MACE,6BAA6B;MAC7B,aAAa;MACb,YAAY;MACZ,UAAU;MACV,kBAAkB;;MAElB;QACE,UAAU;QACV,6BAA6B;QAC7B,aAAa;QACb,YAAY;QACZ,eAAe;MACjB;IACF;EACF;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":[".container {\n  padding: 0px 10px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.clientsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 10px;\n  padding: 10px 10px 0px;\n  width: 95%;\n  min-height: 110px;\n  box-sizing: border-box;\n\n  .searchContainer {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n  }\n}\n\n.clientsTable {\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  border: 1px solid var(--eaecf0-border);\n  display: flex;\n  flex-direction: column;\n  max-height: 70vh;\n  overflow: hidden;\n}\n\n.inputWrapperHover {\n  position: relative;\n  height: 28px;\n  width: 28px;\n  min-width: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.inputWrapperHover:hover {\n  .inputContainer {\n    opacity: 1;\n  }\n}\n\n.inputContainer {\n  background-color: var(--_52525261-background);\n  transition: all 300ms;\n  width: 25px;\n  border-radius: 999px;\n  height: 25px;\n\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 300ms;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  border-radius: 0 10px 10px 0;\n}\n\n.searchInput {\n  padding: 10px 10px 10px 35px;\n  border: 1px solid var(--ccc-border);\n  border-radius: 10px;\n  font-size: 16px;\n  outline: none;\n  width: 250px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n\n  &::placeholder {\n    color: var(--aaa-color);\n  }\n}\n\n\n\n\n.addButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  height: 40px;\n  width: 40px;\n  background-color: var(--_10A37F-background);\n  color: var(--white-color);\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 7px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  -ms-border-radius: 7px;\n  -o-border-radius: 7px;\n\n  img {\n    width: 15px;\n    height: 15px;\n  }\n\n  &:hover {\n    background-color: var(--_122521-background);\n  }\n}\n\n\n\n.name {\n  color: var(--_3-color);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n\n  img {\n    width: 30px;\n    height: 30px;\n  }\n\n  >div {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n\n.table {\n  min-width: 100%;\n  text-align: start;\n  table-layout: fixed;\n  border-collapse: collapse;\n  width: fit-content;\n\n\n  thead {\n    background-color: var(--f5-background);\n    position: sticky;\n    top: 0;\n    z-index: 10;\n  }\n\n\n  tbody {\n    background-color: var(--white-background);\n\n    p {\n      margin: 0;\n    }\n\n    tr {\n      border-top: 1px solid var(--eaecf0-border);\n      border-bottom: 1px solid var(--eaecf0-border);\n      height: 20px;\n      width: 100%;\n      cursor: pointer;\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n  }\n\n  th {\n    text-align: start;\n    padding: 4px 10px 4px 0px;\n    color: var(--_3-color);\n    font-weight: 500;\n    width: 150px;\n    color: var(--_6-color);\n    font-size: 14px;\n\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  th:first-child,\n  td:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 1;\n    width: 20px;\n  }\n\n  th:first-child {\n    background-color: var(--f5-background);\n    z-index: 11;\n  }\n\n  td {\n    padding: 10px;\n    color: var(--_6-color);\n    font-size: 13px;\n    height: 20px;\n    position: relative;\n\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    p {\n      margin: 0;\n    }\n\n    &:first-of-type {\n      display: inline-table;\n      background: var(--white-color);\n      margin-top: 13px;\n      min-width: 20px;\n      width: 20px;\n      max-width: 20px;\n    }\n\n    &:empty {\n      position: relative;\n    }\n\n    &:empty::after {\n      content: \" - - \";\n      color: var(--_1d-color);\n      font-size: 10px;\n      font-style: italic;\n      position: absolute;\n      left: 50%;\n      transform: translate(-40px, -10px);\n      background: linear-gradient(90deg, var(--f5-background) 0%, var(--white-background) 50%, var(--f5-background) 100%);\n      background-size: 200% 100%;\n      animation: wave 2s ease-in-out infinite;\n      padding: 5px 8px;\n      border-radius: 10px;\n      z-index: 0;\n    }\n  }\n\n\n  thead th {\n    white-space: nowrap;\n    text-transform: capitalize;\n    padding-left: 4px;\n  }\n\n\n\n  td p:first-of-type {\n    margin-bottom: 0;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n}\n\n.actions {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n\n  img {\n    cursor: pointer;\n  }\n}\n\n@keyframes wave {\n  0% {\n    background-position: 200% 0;\n  }\n\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.transacciones {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  width: 100px;\n\n  a {\n    font-weight: bold;\n  }\n\n  a,\n  span {\n    color: var(--_073f31-color);\n  }\n}\n\n\n.transacciones {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n\n  a {\n    font-weight: bold;\n  }\n\n  a,\n  span {\n    color: var(--_073f31-color);\n  }\n}\n\ninput[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n}\n\n.bg {\n  background-color: var(--_FFFFFF80-background);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.newClientContainer {\n  background-color: var(--white-background);\n  padding-bottom: 20px;\n  height: 80vh;\n  width: 80%;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  animation: scaleUp 300ms ease-out forwards;\n  -webkit-animation: scaleUp 300ms ease-out forwards;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n\n\n\n}\n\n.typeClient {\n  display: flex;\n  background-color: var(--f3-background);\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  padding: 6px;\n  gap: 10px;\n  width: 300px;\n\n  button {\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    flex: 1;\n    background-color: transparent;\n  }\n}\n\n.typeClientActivate {\n  button {\n    background-color: transparent;\n    cursor: pointer;\n    color: var(--_9-color);\n  }\n\n  .selected {\n    background-color: var(--white-background);\n    box-shadow: 0px 3px 8px var(--ac-shadow);\n    color: var(--black-color);\n  }\n}\n\n.typeClientDisabled {\n  background-color: transparent;\n}\n\n.button {\n  cursor: pointer;\n  background-color: transparent;\n  text-decoration: underline;\n  font-weight: 600;\n  color: var(--_18181b_color);\n  font-size: 14px;\n}\n\n\n\n.headerPhoneNumer {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.unknown {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--_71-color);\n}\n\n.phoneNumber {\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  gap: 10px;\n}\n\n.buttonPhoneContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.phoneContainerUnknown {\n  display: flex;\n  width: 100%;\n}\n\n.phoneContainer {\n  width: 100%;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-direction: column;\n\n  .phoneRow {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .delete {\n    background-color: var(--dc3545-background);\n    height: 20px;\n    min-width: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    cursor: pointer;\n\n    .icon {\n      height: 13px;\n      width: 13px;\n    }\n  }\n}\n\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n\n.thPointer {\n  cursor: pointer;\n}\n\n.thWithInitial {\n  cursor: pointer;\n  position: initial\n}\n\n.thInitial {\n  position: initial\n}\n\n.thInitial:hover .chevronIcon {\n  opacity: 1;\n}\n\n\n.chevronIcon {\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  transform: rotate(180deg);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  min-width: 12px;\n  min-height: 12px;\n}\n\n\n.thPointer:hover .chevronIcon {\n  opacity: 1;\n}\n\n.thWithInitial:hover .chevronIcon {\n  opacity: 1;\n}\n\n\n\n\n\n\n\n.seeMoreContainer {\n  display: flex;\n  justify-content: end;\n  color: var(--_6-color);\n  cursor: pointer;\n}\n\n.columnTitle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  span {\n    color: var(--black-color);\n    display: flex;\n    align-items: center;\n    gap: 3px;\n\n    button {\n      background-color: transparent;\n      outline: none;\n      border: none;\n      left: -5px;\n      position: relative;\n\n      .icon {\n        opacity: 0;\n        background-color: transparent;\n        outline: none;\n        border: none;\n        cursor: pointer;\n      }\n    }\n  }\n\n  div {\n    text-decoration: underline;\n  }\n}\n\n.thPointer:hover .icon {\n  opacity: 1;\n}\n\n.thWithInitial:hover .icon {\n  opacity: 1;\n}\n\n.thPointer:hover .icon {\n  opacity: 1;\n}\n\n.thInitial:hover .icon {\n  opacity: 1;\n}\n\n.theadShowThead {\n  z-index: 1 !important;\n}\n\n.theadHideThead {\n  z-index: 10 !important;\n}\n\n.scrollWrapper {\n  flex: 1;\n  overflow: auto;\n  width: 100%;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.scrollWrapper::-webkit-scrollbar {\n  display: none;\n}\n\n.resizer {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 5px;\n  cursor: col-resize;\n  z-index: 10;\n}\n\n.iconParameter{\n  width: 20px;\n  height: 20px;\n  fill: var(--_3-color);\n  color: var(--_3-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_DM7U6`,
	"clientsHeader": `clientsHeader_gp0g4`,
	"searchContainer": `searchContainer_NOGJg`,
	"clientsTable": `clientsTable_OsJ2z`,
	"inputWrapperHover": `inputWrapperHover_K7lDh`,
	"inputContainer": `inputContainer_WSz_C`,
	"inputWrapper": `inputWrapper_t48oo`,
	"searchInput": `searchInput_qRyzl`,
	"addButton": `addButton_vouox`,
	"name": `name_DLAmD`,
	"table": `table_JsmAl`,
	"wave": `wave_M7LMa`,
	"actions": `actions_sO7jz`,
	"transacciones": `transacciones_hym2Z`,
	"bg": `bg_IqgAH`,
	"newClientContainer": `newClientContainer_UrAE1`,
	"scaleUp": `scaleUp_Om2Hk`,
	"typeClient": `typeClient_rUjka`,
	"typeClientActivate": `typeClientActivate_DDe3x`,
	"selected": `selected_dRx23`,
	"typeClientDisabled": `typeClientDisabled_Qb0ej`,
	"button": `button_Rd1Kc`,
	"headerPhoneNumer": `headerPhoneNumer_gRuaA`,
	"unknown": `unknown_K9jjd`,
	"phoneNumber": `phoneNumber_ObyJn`,
	"buttonPhoneContainer": `buttonPhoneContainer_BZ5w6`,
	"phoneContainerUnknown": `phoneContainerUnknown_xxRF6`,
	"phoneContainer": `phoneContainer_fCxBl`,
	"phoneRow": `phoneRow_HiQRF`,
	"delete": `delete_rocMs`,
	"icon": `icon_bjOLl`,
	"searchIconsWrappers": `searchIconsWrappers_Uhx3e`,
	"thPointer": `thPointer_WoGIM`,
	"thWithInitial": `thWithInitial_wdEbQ`,
	"thInitial": `thInitial_L786p`,
	"chevronIcon": `chevronIcon_GExD2`,
	"seeMoreContainer": `seeMoreContainer_P1zoW`,
	"columnTitle": `columnTitle_e37Im`,
	"theadShowThead": `theadShowThead_pJJd1`,
	"theadHideThead": `theadHideThead_DdoBk`,
	"scrollWrapper": `scrollWrapper_WNP8k`,
	"resizer": `resizer_Wj0eM`,
	"iconParameter": `iconParameter_eMvqL`
};
export default ___CSS_LOADER_EXPORT___;
